import React from "react";
import SharedLayout from "components/routes/shared-layout/SharedLayout";
import { useDashboardShellData } from "./hooks/useDashboardShellData";

export const DashboardShellContent: React.FC = () => {
  const dashboardData = useDashboardShellData();
  return <SharedLayout dashboardData={dashboardData} />;
};

export default DashboardShellContent;
